import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { RemoteRefreshScheduleMapper } from '../mappers/RemoteRefreshScheduleMapper';
import { IRemoteRefreshScheduleInfo } from '../models/IRemoteRefreshScheduleInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { CreateRemoteRefreshScheduleRequest } from '../ServerApi/requests/CreateRemoteRefreshScheduleRequest';
import { DeleteRemoteRefreshSchedulesRequest } from '../ServerApi/requests/DeleteRemoteRefreshSchedulesRequest';
import { GetRemoteRefreshSchedulesRequest } from '../ServerApi/requests/GetRemoteRefreshSchedulesRequest';
import { UpdateRemoteRefreshExpectedDurationRequest } from '../ServerApi/requests/UpdateRemoteRefreshExpectedDurationRequest';
import { UpdateRemoteRefreshScheduleRequest } from '../ServerApi/requests/UpdateRemoteRefreshScheduleRequest';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { FetcherFactory } from '../services/FetcherFactory';
import { Resource } from './Resource';
import {WebClientListResourceFetcher} from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import {ResourceQuery} from './ResourceQuery';

export class RemoteRefreshSchedulesResource {

  private fetcher = new WebClientListResourceFetcher(
    GetRemoteRefreshSchedulesRequest, ServerApiMapper.remoteRefreshSchedules);

  public all(): ResourceQuery<IRemoteRefreshScheduleInfo>{
    return new ResourceQuery(this.fetcher);
  }

  public create(targetId: string, item: IRemoteRefreshScheduleInfo): Promise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new CreateRemoteRefreshScheduleRequest({
      targetId: targetId,
      definition: '',
      refreshType: item.refreshType,
      schedule: {
        definition: '',
        refreshType: item.refreshType,
        scheduleDetails: item.scheduleDetails,
        scheduleType: item.scheduleType
      }
    }));
  }

  public update(targetId: string, initialSchedule: IRemoteRefreshScheduleInfo, finalSchedule: IRemoteRefreshScheduleInfo): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateRemoteRefreshScheduleRequest({
      targetId: targetId,
      initial: RemoteRefreshScheduleMapper.mapSingleToApi(initialSchedule),
      final: RemoteRefreshScheduleMapper.mapSingleToApi(finalSchedule)
    }));
  }

  public del(targetId: string, items: Set<IRemoteRefreshScheduleInfo>): ng.IPromise<IResult> {
    const schedules = items.toArray();
    return WebHttpClientWithErrorToastInstance.sendRequests(
      RequestHelper.buildRequests(schedules, (schedulesBlock) =>
        new DeleteRemoteRefreshSchedulesRequest({
          targetId: targetId,
          schedules: RemoteRefreshScheduleMapper.mapToApi(schedulesBlock)
      })),
      ResultHelper.combineResults);
  }

  public updateExpectedDuration(targetId: string, finalSchedule: IRemoteRefreshScheduleInfo): ng.IPromise<IResult> {
    return WebHttpClientWithErrorToastInstance.sendRequest(new UpdateRemoteRefreshExpectedDurationRequest({
      id: targetId,
    expectedRefreshDuration: (String)(finalSchedule.expectedRefreshDuration)
    }));
  }

}

export const RemoteRefreshSchedules = new RemoteRefreshSchedulesResource();